import { ICourseSuggestion } from "./firestoreMappings";

export const isICourseSuggestion = (arg: any): arg is ICourseSuggestion => {
  return arg && arg.typeGuard === "ICourseSuggestion";
};
